module.exports = __webpack_public_path__ + "static/media/AsusVivoBook15Ryzen5QuadCore.dc62b097.jpeg";